define(['core/browser-storage'], function (browser_storage) {
    let automationBanner = document.querySelector(".automation-banner");
    let pageName = automationBanner.dataset.page;
    let shortName = pageName.replace(/\s+/g, '-').toLowerCase();
    let bannerState = browser_storage.getItem(`hide-${shortName}-automation-banner`);

    let hasAutomations = automationBanner.dataset.automationsCount !== "0";

    let initBanner = () => {
        if (!bannerState && !hasAutomations) {
            let dismissButton = automationBanner.querySelector(".dismiss");

            dismissButton.addEventListener("click", () => {
                browser_storage.setItem(`hide-${shortName}-automation-banner`, true);
                automationBanner.classList.add("hide");
            })
        
            automationBanner.classList.remove("hide");
        }
    }
    
    return initBanner;
});